import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateModule } from "@ngx-translate/core";

import { QuickAppProMaterialModule } from "../modules/material.module";

import { PageHeaderComponent } from './page-header.component'
import { UserEditorComponent } from '../admin/user-editor.component';
import { AppDialogComponent } from './app-dialog.component';

import { GroupByPipe } from '../pipes/group-by.pipe';
import { DateFormatterPipe } from '../pipes/dateformatter.pipe';
import { BoolYesNoTranslatorPipe } from '../pipes/boolyesnotranslator.pipe';

@NgModule({
    imports: [
        FormsModule, ReactiveFormsModule,
        BrowserModule, BrowserAnimationsModule,
        QuickAppProMaterialModule,
        TranslateModule
    ],
    exports: [
        FormsModule, ReactiveFormsModule,
        BrowserModule, BrowserAnimationsModule,
        QuickAppProMaterialModule,
        TranslateModule,
        PageHeaderComponent,
        GroupByPipe,
        BoolYesNoTranslatorPipe,
        DateFormatterPipe,
        UserEditorComponent,
        AppDialogComponent
    ],
    declarations: [
        PageHeaderComponent,
        GroupByPipe,
        BoolYesNoTranslatorPipe,
        DateFormatterPipe,
        UserEditorComponent,
        AppDialogComponent
    ]
})
export class SharedModule
{

}
